import { SignUp } from '@clerk/react';
import { Container, Center } from '@mantine/core';

const RegisterPage = () => {
  return (
    <Container size="sm" py="xl">
      <Center>
        <SignUp routing="path" path="/register" signInUrl="/login" />
      </Center>
    </Container>
  );
};

export default RegisterPage;
